import { render, staticRenderFns } from "./WidgetsDispatcher.vue?vue&type=template&id=10b6ebf6"
import script from "./WidgetsDispatcher.vue?vue&type=script&lang=js"
export * from "./WidgetsDispatcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports